var exports = {
  "Q": "xa15a2ab7--bcd091--content",
};

module.exports = exports;
